import { useParameterStore } from '@/frontend/store/ParameterStore';
import { ParameterSubjectType, ParameterType } from '@/types/parameterTypes';
import { Parameter } from '@/backend/models/parameter';
import { useShallow } from 'zustand/react/shallow';
import { CustomFieldInput } from '../customFIelds/CustomFieldInput';
import { NonPrimitiveParameter } from '../parameters/NonPrimitiveParameter';
import { Form } from 'react-bootstrap';

export function ProcedureCreateParameters(props: { subjectId: string, type: ParameterType }) {
  const { subjectId, type } = props;
  const parameters = useParameterStore(useShallow((state) => state.parameters.filter((parameter) =>
    !parameter.viewOnly 
    && parameter.subjectId === subjectId 
    && parameter.subjectType === ParameterSubjectType.PROCEDURE 
    && parameter.type === type
  )));

  if (parameters.length === 0) {
    return null;
  }

  return (
    <div className='d-flex flex-column gap-3'>{parameters.map(parameter => <ProcedureCreateParameterItem key={parameter.id} parameter={parameter}/>)}</div>
  );
}

function ProcedureCreateParameterItem(props: { parameter: Parameter }) {
  const { parameter } = props;

  return (
    <div className='mt-1' id={parameter.id}>
      <div className='d-flex flex-column'>
        <Form.Label className='form-label-neutral'>{parameter.title}</Form.Label>
        {parameter.description && <span className='text-muted pb-1 text-wrap text-break'>{parameter.description}</span>}
        <ProcedureCreateParameterValue parameter={parameter} />
      </div>
    </div>
  );
}

function ProcedureCreateParameterValue(props: { parameter: Parameter }) {
  const { parameter } = props;

  if (parameter.isPrimitive()) {
    return <CustomFieldInput customField={parameter.fields[0]} />;
  }

  return <NonPrimitiveParameter parameter={parameter} runView />;
}
